export const CRS: string = "https://www.eecs.yorku.ca/~roumani/course/3481";
